module.exports = __webpack_public_path__ + "media/pricing/Maintenance_Agreement-8deac18f.pdf";